import classes from '../../Classes';
var defaultAlignment = function defaultAlignment() {
  return {
    getGridAlignment: function getGridAlignment() {
      return classes.GRID_ALIGNMENT.START;
    },
    getAlignment: function getAlignment() {
      return classes.ALIGNMENT.LEFT;
    },
    getVerticalAlignment: function getVerticalAlignment() {
      return classes.VERTICAL_ALIGNMENT.CENTER;
    }
  };
};
export default defaultAlignment;